import React from 'react';
import { Container } from 'styles/components/ModalWrapper';

const ModalWrapper = ({ children, className }) => (
  <Container className={className}>{children}</Container>
);

export default ModalWrapper;
